import moment from 'moment';
import { EditProfile } from '_components/Profile/EditProfile';
import { preventNegativeValueInDocs, getProgressStatusText } from '_helpers/helpers';
import { dateTimeConstants } from '_constants';
import DatePicker from 'react-datepicker';
import { Controller } from 'react-hook-form';
import PropTypes from "prop-types";

export default function IfcaContract({ profileData, refetchUser, currentUserPermissions, authUser, dropdownData }) {
  return (
    <div className='mb-2'>
      <div>
        <div className='qualifications_header-tab'>
          <h3>IFCA Contract</h3>
        </div>
      </div>
      <div className='qualifications_header-tab'>

        <div className='qualification-row'>
          <label>FFT1</label>
          <div className='input-like-box'>
            <div className='input-like-box_field'>
              <span>
                {profileData.ifca_fft1_status
                  ? getProgressStatusText(
                      profileData.ifca_fft1_status,
                      profileData.ifca_fft1_date,
                    )
                  : '-'}
              </span>
            </div>
            <EditProfile
              label='IFCA FFT1'
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={currentUserPermissions.includes(
                'Manage Expiry/Assigned Dates',
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Status</label>
                  <select
                    {...register('ifca_fft1_status', {
                      required: 'Status is required',
                    })}
                    defaultValue={profileData.ifca_fft1_status}
                    className={
                      errors.ifca_fft1_status && 'profile-form-field-error'
                    }
                  >
                    <option value=''>Select Status</option>
                    <option value='1'>Sent</option>
                    <option value='2'>Approved</option>
                  </select>
                  {errors.ifca_fft1_status && (
                    <p className='error-message'>
                      {errors.ifca_fft1_status.message}
                    </p>
                  )}

                  <label>Date</label>
                  <Controller
                    name='ifca_fft1_date'
                    control={control}
                    defaultValue={
                      profileData.ifca_fft1_date
                        ? moment(profileData.ifca_fft1_date).format(
                            dateTimeConstants.DATE_FORMAT,
                          )
                        : null
                    }
                    rules={{
                      required: 'Date is required',
                    }}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : '',
                          )
                        }
                        customInput={<input inputMode='none' />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText='Select Date'
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.ifca_fft1_date && (
                    <p className='error-message'>
                      {errors.ifca_fft1_date.message}
                    </p>
                  )}
                </>
              )}
            </EditProfile>
          </div>
        </div>
        <div className='qualification-row'>
          <label>CRWB</label>
          <div className='input-like-box'>
            <div className='input-like-box_field'>
              <span>
                {profileData.ifca_crwb_status
                  ? getProgressStatusText(
                      profileData.ifca_crwb_status,
                      profileData.ifca_crwb_date,
                    )
                  : '-'}
              </span>
            </div>
            <EditProfile
              label='IFCA CRWB'
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={currentUserPermissions.includes(
                'Manage Expiry/Assigned Dates',
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Status</label>
                  <select
                    {...register('ifca_crwb_status', {
                      required: 'Status is required',
                    })}
                    defaultValue={profileData.ifca_crwb_status}
                    className={
                      errors.ifca_crwb_status && 'profile-form-field-error'
                    }
                  >
                    <option value=''>Select Status</option>
                    <option value='1'>Sent</option>
                    <option value='2'>Approved</option>
                  </select>
                  {errors.ifca_crwb_status && (
                    <p className='error-message'>
                      {errors.ifca_crwb_status.message}
                    </p>
                  )}

                  <label>Date</label>
                  <Controller
                    name='ifca_crwb_date'
                    control={control}
                    defaultValue={
                      profileData.ifca_crwb_date
                        ? moment(profileData.ifca_crwb_date).format(
                            dateTimeConstants.DATE_FORMAT,
                          )
                        : null
                    }
                    rules={{
                      required: 'Date is required',
                    }}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : '',
                          )
                        }
                        customInput={<input inputMode='none' />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText='Select Date'
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.ifca_crwb_date && (
                    <p className='error-message'>
                      {errors.ifca_crwb_date.message}
                    </p>
                  )}
                </>
              )}
            </EditProfile>
          </div>
        </div>

        <div className='qualification-row'>
          <label>LSA</label>
          <div className='input-like-box'>
            <div className='input-like-box_field'>
              <span>{profileData.lsa ? profileData.lsa : '-'}</span>
            </div>
            <EditProfile
              label='LSA'
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={currentUserPermissions.includes(
                'Manage Expiry/Assigned Dates',
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Status</label>
                  <select
                    {...register('lsa', {})}
                    defaultValue={profileData.lsa_id}
                    className={errors.lsa && 'profile-form-field-error'}
                  >
                    <option value=''>Select Status</option>
                    {(dropdownData?.Lsa ?? []).map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.value}
                      </option>
                    ))}
                  </select>
                  {errors.lsa && (
                    <p className='error-message'>{errors.lsa.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </div>
        </div>
      </div>
    </div>
  );
}

IfcaContract.propTypes = {
  profileData: PropTypes.object.isRequired,
  refetchUser: PropTypes.func,
  currentUserPermissions: PropTypes.array,
  authUser: PropTypes.any,
  dropdownData: PropTypes.object,
};
